<template>
  <transition :name="transitionName">
    <div v-show="value" v-if="rendered" :class="['entity-slider', 'slider-' + this.position]">
      <el-tabs v-model="component">
        <el-tab-pane v-for="(tab, key) in tabs" :key="key" :label="tab.title" :name="tab.comp" :lazy="true">
          <component :is="tab.comp" :ref="tab.comp" @change="handleSelect" :class="['direct-' + position]"></component>
        </el-tab-pane>
      </el-tabs>
      <i class="el-icon-menu arrow-switch" @click="switchPosition"></i>
      <i class="el-icon-close arrow-close" @click="hide"></i>
    </div>
  </transition>
</template>

<script>
import kewen from './../../kewen/KewenEntityList'
import word from './../../word/WordEntityList'
import grammar from './../../grammar/GrammarEntityList'
import grammarGraphic from './../../grammar/GrammarEntityGraphicList'
import exercise from './../../exercise/ExerciseEntityList'
import titlepage from './TitlePageEntityList'
import sentence from '@/views/sentence/SentenceEntityList'
import create from './LessonEntityCreate'

export default {
  name: 'LessonEntitySelect',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: String,
    direction: {
      type: String,
      default: 'right'
    }
  },
  components: { create, kewen, word, grammar, exercise, sentence, titlepage, grammarGraphic },
  data () {
    return {
      rendered: false,
      position: this.direction,
      component: 'word',
      tabs: [
        { title: '创建', comp: 'create' },
        //{ title: '扉页', comp: 'titlepage' },
        { title: '选择词汇', comp: 'word' },
        { title: '选择课文', comp: 'kewen' },
        { title: '选择语法', comp: 'grammar' },
        { title: '选择解释页', comp: 'grammarGraphic' },
        { title: '选择例句', comp: 'sentence' },
        { title: '选择题目', comp: 'exercise' }
      ]
    }
  },
  watch: {
    direction (val) {
      this.position = val
    },
    position () {
      this.toggleRootClass()
    },
    value: {
      handler (val) {
        if (val) {
          this.rendered = true
        }
        this.toggleRootClass()
      },
      immediate: true
    },
    component(val, old) {
      if (this.$refs[old] && this.$refs[old][0].tabdeactivated) {
        this.$refs[old][0].tabdeactivated()
      }
      if (this.$refs[val] && this.$refs[val][0].tabactivated) {
        this.$refs[val][0].tabactivated()
      }
    }
  },
  computed: {
    transitionName () {
      return 'slider-' + this.position
    }
  },
  methods: {
    toggleRootClass () {
      this.$root.$el.classList.remove('entity-select-right', 'entity-select-bottom')
      if (this.value) {
        this.$root.$el.classList.add('entity-select-open', 'entity-select-' + this.position)
      } else {
        this.$root.$el.classList.remove('entity-select-open')
      }
    },
    switchPosition () {
      this.position = this.position === 'right' ? 'bottom' : 'right'
    },
    hide () {
      this.$emit('input', false)
    },
    handleSelect (model) {
      let params = {
        entity_type: model.type,
        status: 1
      }
      if (model.entity.id) {
        params.entity_id = model.entity.id
      } else {
        params.entity = model.entity
      }
      this.$emit('select', params)
    }
  }
}
</script>

<style lang="scss" scoped>
  .slider-right-enter, .slider-right-leave-to {
    transform: translate(100%, 0);
  }
  .slider-bottom-enter, .slider-bottom-leave-to {
    transform: translate(0, 100%);
  }
  .slider-right-enter-to, .slider-right-leave,
  .slider-bottom-enter-to, .slider-bottom-leave {
    transform: translate(0px, 0px);
    transition: transform .3s;
  }
  .slider-right-enter, .slider-right-leave-to,
  .slider-bottom-enter, .slider-bottom-leave-to{
    opacity: 0;
    transition: opacity .3s ease-in-out .3s, transform .3s ease-in-out;
  }
  
  .entity-slider{
    position: fixed;
    background: white;
    z-index: 999;
    padding: 15px;
    border-left: 1px solid #ebeef5;
    box-shadow: 15px 15px 15px 15px rgba(0,0,0,.2);
    &.slider-right{
      right: 0;
      top: 0;
      bottom: 0;
      width: 50%;
      max-width: 800px;
    }
    &.slider-bottom{
      left: 0;
      right: 0;
      bottom: 0;
      height: 50vh;
    }
  }
  .arrow-switch,
  .arrow-close{
    position: absolute;
    right: 15px;
    top:20px;
    &:hover{
      color: #409eff;
      cursor: pointer;
    }
  }
  .arrow-switch{
    right: 40px;
  }
</style>

<style lang="scss">
  .entity-slider > .el-tabs{
    > .el-tabs__content{
      position: absolute;
      top: 70px;
      left: 15px;
      right: 15px;
      bottom: 15px;
      overflow-y: auto;
      >.el-tab-pane{
        min-height: 100%;
      }
    }
  }
</style>
